<div fxLayout="column" fxFlex="0 0 100%" class="hr-notes-wrapper">
    <app-table-filter-expansion-panel
        *ngIf="hasExpansionFilter"
        class="task-expansion"
        #filterExpansion
        [hasTopBorder]="true"
    >
        <ng-container *ngTemplateOutlet="filters"></ng-container>
    </app-table-filter-expansion-panel>
    <ng-container *ngIf="!hasExpansionFilter">
        <ng-container *ngTemplateOutlet="filters"></ng-container>
    </ng-container>

    <!-- <mat-progress-bar
        class="progress-table-loader"
        *ngIf="(dataSource.status | async) === 'loading'"
        mode="indeterminate"
    ></mat-progress-bar> -->
    <mat-table #table [dataSource]="dataSource" matSortActive="created_at" matSortDirection="desc" matSort>
        <ng-container matColumnDef="thumbnil">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Image</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span class="mobile-label" i18n>Image:</span>
                <app-image-view
                    [showImgModalOnClick]="true"
                    [smallSpinner]="true"
                    [media_id]="media"
                    [proportional]="true"
                    (onCloseImgModal)="refreshMediaListing()"
                ></app-image-view>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="id">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Id</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span class="mobile-label" i18n>Id:</span>
                <div [matTooltip]="media.priority" class="id-column">
                    <span>{{ media.id }}</span>
                    <span *ngIf="significantPrio.includes(media.priority)" class="prio {{ media.priority }}">*</span>
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="filename">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Name</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span class="mobile-label" i18n>Name:</span>
                <span class="notes">{{ media.name ?? media.filename }}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="created_at">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Created at</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span>{{ media.created_at | kdDateFormat : 'YYYY-MM-DD' }}</span></mat-cell
            >
        </ng-container>
        <ng-container matColumnDef="updated_at">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Last edit</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span>{{ media.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm' }}</span></mat-cell
            >
        </ng-container>
        <ng-container matColumnDef="author">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Creator</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span class="mobile-label" i18n>Creator:</span>
                <span class="author-name" *ngIf="file.author?.name" [matTooltip]="file.author?.name">{{
                    file.author?.name | nameSign
                }}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="priority">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Priority</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span class="mobile-label" i18n>Priority:</span>
                <app-item-change-on-the-fly
                    class="customer-item-not-task {{ file.priority }}"
                    [capitalize]="true"
                    [selectionOptions]="filePrioOptions"
                    [value]="file.priority"
                    (onValueChange)="onSelectPriority(file, $event)"
                ></app-item-change-on-the-fly>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="visibility">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Status</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <div
                    *ngIf="!media.isProcessing()"
                    class="visibility-cell"
                    fxLayoutAlign="start center"
                    fxLayoutGap="5px"
                    [ngClass]="{
                        darkblue: media.visibility == 'public',
                        grey: media.visibility == 'private',
                        iceblue: media.visibility == 'academy'
                    }"
                >
                    <mat-icon
                        [ngClass]="{
                            darkblue: media.visibility == 'public',
                            grey: media.visibility == 'private',
                            iceblue: media.visibility == 'academy'
                        }"
                        [matTooltip]="media.visibility"
                    >
                        {{
                            media.visibility == 'public'
                                ? 'public'
                                : media.visibility == 'private'
                                ? 'public_off'
                                : 'published_with_changes'
                        }}
                    </mat-icon>
                </div>
                <mat-icon class="ai-icon" *ngIf="!!media?.isProcessing()">smart_toy</mat-icon>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n="@@description">Description</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span>{{ media.description }}</span></mat-cell
            >
        </ng-container>
        <ng-container matColumnDef="tags">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Tags</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span *ngIf="isMobile" class="mobile-label" i18n> Tags </span>
                <app-table-tags-on-the-fly
                    (click)="$event.stopPropagation()"
                    [tags]="media.tags"
                    (onUpdateTags)="media?.id && updateMediaTags(media, $event)"
                    (onTagClick)="onTagClick($event)"
                ></app-table-tags-on-the-fly>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Id</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span class="mobile-label" i18n>Id:</span>
                <span>{{ media.id }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tools">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell class="btns-actions" *matCellDef="let media">
                <mat-icon
                    i18n-matTooltip="@@favorite"
                    (click)="$event.stopPropagation(); favorite(media)"
                    [ngStyle]="{ color: '#bfd8d0' }"
                    class="grey favorite-button"
                    matTooltip="Favorite"
                    >{{ media.favorite ? 'star' : 'star_border' }}</mat-icon
                >
                <button
                    (click)="$event.stopPropagation(); createMaterial(media)"
                    matTooltip="Create material"
                    mat-icon-button
                    i18n-matTooltip="@@createMaterial"
                    class="creat-mat"
                >
                    <mat-icon
                        fxFlex="0 0 auto"
                        color="primary"
                        fontSet="klickdata"
                        fontIcon="kd-icon-document"
                        class="course-plan-icon kd-icon-24 no-shadow"
                    ></mat-icon>
                </button>
                <button
                    (click)="$event.stopPropagation(); view(media)"
                    matTooltip="View"
                    mat-icon-button
                    i18n-matTooltip="@@view"
                >
                    <mat-icon>visibility</mat-icon>
                </button>

                <button
                    (click)="$event.stopPropagation(); delete(media.id)"
                    matTooltip="Delete"
                    mat-icon-button
                    i18n-matTooltip="@@delete"
                    class="comment-add"
                >
                    <mat-icon>delete</mat-icon>
                </button>
                <button
                    (click)="$event.stopPropagation(); edit(media)"
                    [disabled]="!authUser?.canEditMedia(media)"
                    matTooltip="Edit"
                    mat-icon-button
                    i18n-matTooltip="@@edit"
                >
                    <mat-icon>edit</mat-icon>
                </button>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="min_tools">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell class="btns-actions" *matCellDef="let media">
                <button
                    (click)="$event.stopPropagation(); view(media)"
                    matTooltip="View"
                    mat-icon-button
                    i18n-matTooltip="@@view"
                >
                    <mat-icon>visibility</mat-icon>
                </button>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row
            *matRowDef="let media; columns: columns"
            class="example-element-row"
            (click)="onMediaClick.emit(media)"
        ></mat-row>
    </mat-table>
    <mat-paginator [pageSize]="25" [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
</div>

<ng-template #loading>
    <div fxLayout="row" fxLayoutAlign="center center" class="spinner-container mt-2">
        <mat-spinner fxFlex="0 0 auto"></mat-spinner>
    </div>
</ng-template>

<ng-template #filters>
    <app-table-filter [filtersTogglesInOnBtn]="true" [inGlobalFilter]="true" color="accent" #filter>
        <app-table-search
            toggleBtnLabel="File"
            i18n-toggleBtnLabel
            [inGlobalFilter]="true"
            class="align-space"
            searchFilterRef
        ></app-table-search>

        <app-tag-chip-search-filter
            [inGlobalFilter]="true"
            fxFlex="50%"
            fxFlex.lt-md="100%"
            fxLayoutAlign="start"
            tagsFilterRef
        ></app-tag-chip-search-filter>
    </app-table-filter>
</ng-template>
